/**
 * Helper function that checks if static property is set to true on react
 * component or react functional component.
 */
export function reactTypeFlagCheck(reactType: any, staticFlag: string): boolean {
  return typeof reactType === "object" || typeof reactType === "function"
    ? !!reactType[staticFlag]
    : false
}
